// project import
import administration from "./administration";
import companies from "./companies";
import lands from "./lands";
import logistics from "./logistics";
import stores from "./stores";
import products from "./products";
import maintenance from "./maintenance";
import payments from "./payments";
import retingRequests from "./renting-requests";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    administration,
    companies,
    lands,
    logistics,
    stores,
    products,
    maintenance,
    payments,
    retingRequests,
  ],
};

export default menuItems;
